import { Deserializer } from 'jsonapi-serializer';
import { Filter } from "../models/Filter";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getControllerProfilesNames = async (siteId): Promise<Name[]> => {
    try {
        const url = `controllerProfiles?fields[controllerProfiles]=trnName&filter=site.id==${siteId}`;

        const response = await apiConnector.fetchData(url);
        const json = await response.json();

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const controllerProfiles: Name[] = data.map((profile): Name => {
                    return {
                        value: profile['id'],
                        label: profile['trn-name']
                    };
                });

                return resolve(controllerProfiles);
            })


        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}

export const getReaderProfilesNames = async (filters: Filter[], pagination: PaginationModel): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const partialURL = createPartialURL(pagination?.pageNumber, pagination?.maxPageSize, undefined, getFilterClause(filters));
        const url = `readerProfiles?fields[readerProfiles]=trnName${partialURL}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const readerProfiles: Name[] = data.map((profile): Name => {
                    return {
                        value: profile['id'],
                        label: profile['trn-name']
                    };
                });

                return resolve({ rows: readerProfiles, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}

export const getAllEnrolmentProfileNames = async (listQuery?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filters: string = getFilterClause(listQuery?.filters, listQuery?.searchTerm);
        const filterProfileType = "filter=profileType.id==3"
        const updatedFilters = filters.length > 0
            ? filters.replace("filter=", `${filterProfileType};`)
            : `&${filterProfileType}`
        const paginationString = createPartialURL(listQuery?.goToPage, listQuery?.pageSize, listQuery?.sortBy, updatedFilters);
        const url = `profile?fields[profile]=trnName${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);
        
        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const profiles: Name[] = data.map((profile): Name => {
                    return {
                        value: profile['id'],
                        label: profile['trn-name']
                    };
                });

                return resolve({ rows: profiles, pagination: newPagination });
            })


        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        })
    }
}

export const getModuleProfilesNames = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filter = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `moduleProfiles?fields[moduleProfiles]=trnName${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const moduleProfiles: Name[] = data.map((profile): Name => {
                    return {
                        value: profile['id'],
                        label: profile['trn-name']
                    };
                });

                return resolve({ rows: moduleProfiles, pagination: newPagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}
